export const TEXT_ANNOTATION_TYPE = {
  mainOfferings: 'mainOfferings',
  emotions: 'emotions',
  features: 'features',
  pains: 'pains',
  benefits: 'benefits',
  ctas: 'ctas',
  campaignKeywords: 'campaignKeywords',
  headlineType: 'headlineType',
};
